module.exports = __webpack_public_path__ + "static/media/WHT-USDT.dee29fd2.png";